<template>
  <div class="search-page-search-bar-component">
    <div class="search-page-search-bar">
      <div class="search-box">
        <div class="search-box-field">
          <input
            type="text"
            :name="`${pageName}_searchbar`"
            v-model.trim="searchPageStore.searchPageState.search.typing"
            @focus="searchPageStore.searchPageState.search.focus = true"
            @blur="searchPageStore.blurSearchbox"
            @keyup="searchPageStore.handleSearchBarKeyup($event)"
            @keyup.enter="
              searchPageStore.triggerSearch(
                props.pageName,
                searchPageStore.searchPageState.search.typing
              );
              ($event.target as HTMLInputElement).blur();
            "
            :placeholder="searchBoxPlaceholderText"
          />
          <i
            class="icon-cancel"
            v-if="
              searchPageStore.searchPageState.search.typing &&
              searchPageStore.searchPageState.search.typing.length > 0
            "
            @click="
              searchPageStore.clearSearchbox();
              searchPageStore.triggerSearch(props.pageName, null, 1);
            "
          ></i>
        </div>
        <div class="search-box-submit">
          <button
            @click="
              searchPageStore.triggerSearch(
                props.pageName,
                searchPageStore.searchPageState.search.typing,
                1
              )
            "
            class="icon-search"
          >
            <span>Search</span>
          </button>
        </div>
      </div>
      <div
        v-if="searchPageStore.searchPageState.search.error"
        class="search-error"
      >
        Search must contain at least 3 characters.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSearchPageStore } from "@/store/store/searchPageStore";

const searchPageStore = useSearchPageStore();

const props = defineProps({
  pageName: {
    type: String,
    default: "",
  },
  searchBoxPlaceholderText: {
    type: String,
    default: "",
  },
});
</script>

<style scoped>
* {
  font-family: "Montserrat", arial, sans-serif;
}

.search-page-search-bar {
  position: relative;
  width: 100%;
}

div.search-box {
  display: inline-block;
  width: 100%;
}

div.search-box .search-box-field {
  display: inline-block;
}

div.search-box .search-box-field input {
  border-radius: 6px;
  background: #fff;
  height: 34px;
  flex-shrink: 0;
  line-height: normal;
  width: 454px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path d="M7.05714 0C8.92881 0 10.7238 0.743518 12.0473 2.06699C13.3708 3.39046 14.1143 5.18547 14.1143 7.05714C14.1143 8.80514 13.4737 10.412 12.4206 11.6497L12.7137 11.9429H13.5714L19 17.3714L17.3714 19L11.9429 13.5714V12.7137L11.6497 12.4206C10.412 13.4737 8.80514 14.1143 7.05714 14.1143C5.18547 14.1143 3.39046 13.3708 2.06699 12.0473C0.743518 10.7238 0 8.92881 0 7.05714C0 5.18547 0.743518 3.39046 2.06699 2.06699C3.39046 0.743518 5.18547 0 7.05714 0ZM7.05714 2.17143C4.34286 2.17143 2.17143 4.34286 2.17143 7.05714C2.17143 9.77143 4.34286 11.9429 7.05714 11.9429C9.77143 11.9429 11.9429 9.77143 11.9429 7.05714C11.9429 4.34286 9.77143 2.17143 7.05714 2.17143Z" fill="%23CED1D9"/></svg>');
  background-repeat: no-repeat;
  background-position: left calc(0.175em + 0.1875rem) center;
  padding: 0px 25px 0px 30px;
}

div.search-box .search-box-field i {
  margin-left: -25px;
  cursor: pointer;
}

div.search-box-submit {
  display: inline-block;
}

div.search-box-submit button {
  width: 105px;
  height: 34px;
  border-radius: 4px;
  background: #000;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  margin-left: 15px;
}

div.search-box-submit button::before {
  display: none;
}

@media screen and (max-width: 643px) {
  div.search-box .search-box-field {
    display: block;
  }

  div.search-box .search-box-field input {
    width: 100%;
    background-image: none;
    padding: 0 10px;
  }

  div.search-box-submit {
    display: block;
  }

  div.search-box-submit {
    margin: 5px 0 15px 0;
  }

  div.search-box-submit button {
    width: 100%;
    height: 33px;
    margin-left: 0;
  }

  div.search-box-submit button::before {
    display: block;
  }

  div.search-box-submit button span {
    display: none;
  }
}
</style>
